import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.setupHeadingLevels()
  }

  setupHeadingLevels() {
    // Register h2 and h3 as block attributes
    Trix.config.blockAttributes.heading2 = {
      tagName: "h2",
      terminal: true,
      breakOnReturn: true,
      group: false
    }

    Trix.config.blockAttributes.heading3 = {
      tagName: "h3",
      terminal: true,
      breakOnReturn: true,
      group: false
    }

    // Wait for trix-initialize event
    this.element.addEventListener("trix-initialize", (event) => {
      const toolbar = event.target.toolbarElement
      const blockTools = toolbar.querySelector("[data-trix-button-group='block-tools']")

      if (blockTools) {
        // Find the existing heading button and replace it with our dropdown
        const existingHeadingButton = blockTools.querySelector("[data-trix-attribute='heading1']")

        if (existingHeadingButton) {
          // Create heading buttons group (H2 and H3 only - H1 is the article title)
          const headingGroup = document.createElement("span")
          headingGroup.className = "trix-button-group trix-button-group--heading-levels"
          headingGroup.innerHTML = `
            <button type="button" class="trix-button" data-trix-attribute="heading2" title="Section heading" tabindex="-1">H2</button>
            <button type="button" class="trix-button" data-trix-attribute="heading3" title="Subsection heading" tabindex="-1">H3</button>
          `

          // Replace the old heading button
          existingHeadingButton.replaceWith(headingGroup)
        }
      }
    })
  }
}
